import * as constants from './constants'
import { hasAdminCredentials } from './api'

const initialState = {
    allSurveys: [],
    answersSentSuccessfuly: null,
    allAdminSurveys: null,
    textAnswers: [],
    surveyResult: null,
    actualSurvey: null,
    chartData: null,
    addNewSurveyResult: null,
    addNewSurveyError: null,
    csv: null,
    adminAuthenticated: hasAdminCredentials(),
    adminAuthError: null,
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case constants.SET_ALL_SURVEY_BY_COUNTRY_ADMIN:
            return {
                ...state,
                allAdminSurveys: action.data,
            }
        case constants.UPDATE_EXISTING_SURVEY: {
            const replaceUpdated = survey => (survey.surveyId === action.survey.surveyId ? action.survey : survey)

            return {
                ...state,
                allAdminSurveys: state.allAdminSurveys && state.allAdminSurveys.map(replaceUpdated),
                actualSurvey: state.actualSurvey && replaceUpdated(state.actualSurvey),
            }
        }
        case constants.SET_ACTUAL_SURVEY_BY_COUNTRY_ADMIN:
            return {
                ...state,
                actualSurvey: action.data,
            }
        case constants.SET_SURVEY_RESULTS_BY_ID:
            return {
                ...state,
                surveyResult: action.data,
            }
        case constants.SET_SURVEY_TEXT_ANSWER_BY_ID:
            return {
                ...state,
                textAnswers: action.data,
            }
        case constants.SET_ALL_SURVEYS_BY_COUNTRY:
            return {
                ...state,
                allSurveys: action.data,
            }
        case constants.SET_ANSWERS_SENDING_RESULT:
            return {
                ...state,
                answersSentSuccessfuly: action.data,
            }
        case constants.CLEAR_ANSWER_SENT_INDICATOR:
            return {
                ...state,
                answersSentSuccessfuly: null,
            }
        case constants.SET_CHART_DATA:
            return {
                ...state,
                chartData: action.data,
            }
        case constants.ADD_NEW_SURVEY_BY_COUNTRY_RESULT:
            return {
                ...state,
                addNewSurveyResult: action.result,
            }
        case constants.ADD_NEW_SURVEY_BY_COUNTRY_ERROR:
            return {
                ...state,
                addNewSurveyError: action.error,
            }
        case constants.CLEAR_ADD_NEW_SURVEY_BY_COUNTRY_RESULT:
            return {
                ...state,
                addNewSurveyResult: null,
            }
        case constants.CLEAR_ADD_NEW_SURVEY_BY_COUNTRY_ERROR:
            return {
                ...state,
                addNewSurveyError: null,
            }
        case constants.SET_CSV_DATA:
            return {
                ...state,
                csv: action.data,
            }

        case constants.CLEAR_SURVEY_RESULTS_VALUE:
            return {
                ...state,
                surveyResult: null,
            }
        case constants.SET_NPS_ADMIN_AUTHENTICATED:
            return {
                ...state,
                adminAuthenticated: action.authenticated,
            }
        case constants.SET_NPS_ADMIN_AUTH_ERROR:
            return {
                ...state,
                adminAuthError: action.error,
            }
        default:
            return state
    }
}

export default reducer
